import { IconProps, NocIconGenerator } from '../common';

export const Jacuzzi = (props: IconProps): JSX.Element => (
    <NocIconGenerator
        {...props}
        createIconProps={{
            displayName: 'Jacuzzi',
            path: (
                <>
                    <rect
                        x="4.5"
                        y="12.5"
                        width="15"
                        height="9"
                        rx="0.5"
                        stroke="black"
                        strokeLinejoin="round"
                    />
                    <rect x="2.5" y="9.5" width="19" height="3" rx="0.5" stroke="black" />
                    <line
                        x1="7.5"
                        y1="15.5"
                        x2="7.5"
                        y2="18.5"
                        stroke="black"
                        strokeLinecap="round"
                    />
                    <line
                        x1="12"
                        y1="15.5"
                        x2="12"
                        y2="18.5"
                        stroke="black"
                        strokeLinecap="round"
                    />
                    <line
                        x1="16.5"
                        y1="15.5"
                        x2="16.5"
                        y2="18.5"
                        stroke="black"
                        strokeLinecap="round"
                    />
                    <path
                        d="M6.5 3C6.12269 3.34273 5.59445 4.19801 6.5 4.87728C7.40555 5.55655 6.87731 6.57546 6.5 7"
                        stroke="black"
                        strokeLinecap="round"
                    />
                    <path
                        d="M10.5 4C10.1227 4.25705 9.59445 4.89851 10.5 5.40796C11.4055 5.91741 10.8773 6.68159 10.5 7"
                        stroke="black"
                        strokeLinecap="round"
                    />
                </>
            ),
        }}
    />
);
